export default __webpack_public_path__ + "static/primer-components-hero-306dae0ec3ede8c4812f910e7d26b659.svg";